import React, { useState, useEffect } from 'react';
import './ProductsPage.css';
import NavBar from '../components/layout/NavBar';
import ProductSection from '../components/product/ProductSection';
import SideBar from '../components/order/SideBar';
import Footer from '../components/layout/Footer';
import { getProducts, getFilters, getBrands } from '../services/api';
import { Toaster } from 'react-hot-toast';

function ProductsPage() {
  const [productList, setProductList] = useState([]);
  const [filterList, setFilterList] = useState([]);
  const [brandList, setBrandList] = useState([]);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const [products, filters, brands] = await Promise.all([
          getProducts(),
          getFilters(),
          getBrands(),
        ]);

        setProductList(products || []);
        setFilterList(filters || []);
        setBrandList(brands || []);
      } catch (error) {
        console.error("Failed to fetch data:", error);
      }
    };

    fetchData();
  }, []);

  return (
    <div className="products-container">
      <Toaster />
      <NavBar />
      <SideBar />
      <div className="products-content">
        <ProductSection
          productList={productList}
          filterList={filterList}
          brandList={brandList}
        />
      </div>
      <Footer />
    </div>
  );
}

export default ProductsPage;
